import { defineMessages } from 'react-intl';

export const notFoundMessages = defineMessages({
  authError: {
    id: 'not-found.auth-error',
    defaultMessage: 'You may need to login to view this page.',
  },
  logIn: {
    id: 'not-found.log-in',
    defaultMessage: 'Log in',
  },
  links: {
    id: 'not-found.links',
    defaultMessage: 'Here are some helpful links:',
  },
  editVenue: {
    id: 'not-found.edit-venue',
    defaultMessage: 'Edit venue page',
  },
  editClass: {
    id: 'not-found.edit-class',
    defaultMessage: 'Edit class details',
  },
  stats: {
    id: 'not-found.stats',
    defaultMessage: 'Stats',
  },
  classes: {
    id: 'not-found.classes',
    defaultMessage: 'Classes',
  },
  body1: {
    id: 'not-found.body1',
    defaultMessage: 'Whoops!',
  },
  body2: {
    id: 'not-found.body2',
    defaultMessage: 'That’s not how we wanted this to go.',
  },
});
